"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactHooks = require("@trycourier/react-hooks");

var _reactProvider = require("@trycourier/react-provider");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _deepExtend2 = _interopRequireDefault(require("deep-extend"));

var _MarkAllRead = _interopRequireDefault(require("./actions/MarkAllRead"));

var _Close = _interopRequireDefault(require("./actions/Close"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Header__Container",
  componentId: "u2ims4-0"
})(function (_ref) {
  var _theme$brand, _theme$brand$colors, _theme$brand$inapp$bo, _theme$brand2, _theme$brand2$inapp, _theme$brand$inapp$bo2, _theme$brand3, _theme$brand3$inapp;

  var theme = _ref.theme;
  var primaryColor = ((_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary) || "#9121C2";
  return (0, _deepExtend2["default"])({
    padding: "9px 6px",
    userSelect: "none",
    display: "flex",
    position: "relative",
    zIndex: 1,
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: 16,
    fontWeight: 700,
    height: "42px",
    background: "var(--ci-background)",
    borderBottom: "1px solid",
    borderColor: "var(--ci-structure)",
    borderTopLeftRadius: (_theme$brand$inapp$bo = theme === null || theme === void 0 ? void 0 : (_theme$brand2 = theme.brand) === null || _theme$brand2 === void 0 ? void 0 : (_theme$brand2$inapp = _theme$brand2.inapp) === null || _theme$brand2$inapp === void 0 ? void 0 : _theme$brand2$inapp.borderRadius) !== null && _theme$brand$inapp$bo !== void 0 ? _theme$brand$inapp$bo : "12px",
    borderTopRightRadius: (_theme$brand$inapp$bo2 = theme === null || theme === void 0 ? void 0 : (_theme$brand3 = theme.brand) === null || _theme$brand3 === void 0 ? void 0 : (_theme$brand3$inapp = _theme$brand3.inapp) === null || _theme$brand3$inapp === void 0 ? void 0 : _theme$brand3$inapp.borderRadius) !== null && _theme$brand$inapp$bo2 !== void 0 ? _theme$brand$inapp$bo2 : "12px",
    ".message-count": {
      fontSize: 14,
      fontWeight: 400,
      margin: "0 3px",
      background: primaryColor,
      color: "white",
      borderRadius: "17px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: 18,
      padding: "0 6px",
      minWidth: 28
    },
    ".actions": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, theme === null || theme === void 0 ? void 0 : theme.header);
});

var Title = _styledComponents["default"].div.withConfig({
  displayName: "Header__Title",
  componentId: "u2ims4-1"
})(function (_ref2) {
  var _theme$message;

  var theme = _ref2.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$message = theme.message) === null || _theme$message === void 0 ? void 0 : _theme$message.title;
});

var DropdownOptionButton = _styledComponents["default"].button.withConfig({
  displayName: "Header__DropdownOptionButton",
  componentId: "u2ims4-2"
})(function (_ref3) {
  var _theme$brand4, _theme$brand4$colors;

  var theme = _ref3.theme,
      disabled = _ref3.disabled,
      active = _ref3.active,
      selected = _ref3.selected,
      showDropdown = _ref3.showDropdown;
  var primaryColor = ((_theme$brand4 = theme.brand) === null || _theme$brand4 === void 0 ? void 0 : (_theme$brand4$colors = _theme$brand4.colors) === null || _theme$brand4$colors === void 0 ? void 0 : _theme$brand4$colors.primary) || "#9121C2";
  var tcPrimaryColor = (0, _tinycolor["default"])(primaryColor);
  var cssProps = {
    background: active ? primaryColor : "transparent",
    border: "none",
    borderBottom: selected ? undefined : "1px solid",
    borderColor: "var(--ci-structure)",
    cursor: disabled ? "default" : "pointer",
    padding: selected ? "6px" : "12px",
    color: active ? "white" : "var(--ci-title-color)",
    fontWeight: active || selected ? 700 : 400,
    lineHeight: "21px",
    fontSize: "14px",
    display: "flex",
    height: selected ? "24px" : "42px",
    alignItems: "center",
    svg: _objectSpread({
      marginTop: "1px",
      marginLeft: "3px"
    }, showDropdown ? {
      transform: "rotate(180deg)"
    } : {})
  };

  if (!selected) {
    cssProps[".message-count"] = {
      background: "white",
      color: primaryColor
    };
  }

  if (!active && !selected) {
    cssProps["&:hover"] = {
      background: tcPrimaryColor.setAlpha(0.14)
    };
  }

  return cssProps;
});

var HeadingContainer = _styledComponents["default"].div.withConfig({
  displayName: "Header__HeadingContainer",
  componentId: "u2ims4-3"
})(function (_ref4) {
  var _theme$brand5, _theme$brand5$colors, _theme$brand6, _theme$brand6$colors;

  var theme = _ref4.theme,
      hasDropdownOptions = _ref4.hasDropdownOptions;
  var primaryColor = (_theme$brand5 = theme.brand) === null || _theme$brand5 === void 0 ? void 0 : (_theme$brand5$colors = _theme$brand5.colors) === null || _theme$brand5$colors === void 0 ? void 0 : _theme$brand5$colors.primary;
  var tcPrimaryColor = (0, _tinycolor["default"])(primaryColor);
  var styles = {
    display: "flex",
    alignItems: "center",
    borderRadius: 6,
    transition: "background 200ms ease-in-out",
    "svg path": {
      fill: (_theme$brand6 = theme.brand) === null || _theme$brand6 === void 0 ? void 0 : (_theme$brand6$colors = _theme$brand6.colors) === null || _theme$brand6$colors === void 0 ? void 0 : _theme$brand6$colors.primary
    }
  };

  if (hasDropdownOptions) {
    styles["&:hover"] = {
      background: tcPrimaryColor.setAlpha(0.14)
    };
  } else {
    styles["paddingLeft"] = 6;
  }

  return styles;
}); // eslint-disable-next-line @typescript-eslint/no-unused-vars


var HeadingDropdownOptions = _styledComponents["default"].div.withConfig({
  displayName: "Header__HeadingDropdownOptions",
  componentId: "u2ims4-4"
})(function (_ref5) {
  var theme = _ref5.theme;
  return (0, _deepExtend2["default"])({}, (0, _defineProperty2["default"])({
    position: "absolute",
    top: "42px",
    left: 0,
    background: "var(--ci-background)",
    width: "100%",
    zIndex: 2,
    height: "343px"
  }, DropdownOptionButton, {
    width: "100%"
  }), theme.menu);
});

var DownCarrot = function DownCarrot() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "8",
    height: "5",
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.0025 4.9925C3.7425 4.9925 3.4925 4.8925 3.2925 4.7025L0.2925 1.7025C-0.0975 1.3125 -0.0975 0.6825 0.2925 0.2925C0.6825 -0.0975 1.3125 -0.0975 1.7025 0.2925L3.6425 2.2325C3.8425 2.4325 4.1525 2.4325 4.3525 2.2325L6.2925 0.2925C6.6825 -0.0975 7.3125 -0.0975 7.7025 0.2925C8.0925 0.6825 8.0925 1.3125 7.7025 1.7025L4.7025 4.7025C4.5025 4.9025 4.2525 4.9925 3.9925 4.9925H4.0025Z"
  }));
};

var TitleWrapper = function TitleWrapper(_ref6) {
  var title = _ref6.title,
      unreadMessageCount = _ref6.unreadMessageCount;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Title, {
    role: "heading"
  }, title), unreadMessageCount ? /*#__PURE__*/_react["default"].createElement("span", {
    "aria-label": "unread message count ".concat(unreadMessageCount),
    className: "message-count"
  }, unreadMessageCount > 99 ? "99+" : unreadMessageCount) : undefined);
};

var Header = function Header(_ref7) {
  var _brand$preferenceTemp2, _options$find;

  var labels = _ref7.labels,
      markAllAsRead = _ref7.markAllAsRead,
      _ref7$messages = _ref7.messages,
      messages = _ref7$messages === void 0 ? [] : _ref7$messages,
      title = _ref7.title,
      unreadMessageCount = _ref7.unreadMessageCount,
      views = _ref7.views;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showDropdown = _useState2[0],
      setShowDropdown = _useState2[1];

  var _useCourier = (0, _reactProvider.useCourier)(),
      brand = _useCourier.brand;

  var _useInbox = (0, _reactHooks.useInbox)(),
      view = _useInbox.view,
      setView = _useInbox.setView,
      toggleInbox = _useInbox.toggleInbox;

  var handleSetView = function handleSetView(newView) {
    return function (event) {
      event.preventDefault();
      setView(newView);
      setShowDropdown(false);
    };
  };

  var handleShowDropdown = function handleShowDropdown(event) {
    event.preventDefault();
    setShowDropdown(!showDropdown);
  };

  var handleCloseInbox = function handleCloseInbox(event) {
    event.preventDefault();
    toggleInbox(false);
  };

  var options = (0, _react.useMemo)(function () {
    var _brand$preferenceTemp;

    var viewOptions = views === null || views === void 0 ? void 0 : views.map(function (v, index) {
      return {
        id: v.id,
        Component: function Component(_ref8) {
          var active = _ref8.active,
              disabled = _ref8.disabled,
              onClick = _ref8.onClick,
              selected = _ref8.selected,
              showDropdown = _ref8.showDropdown;
          return /*#__PURE__*/_react["default"].createElement(DropdownOptionButton, {
            active: active,
            onClick: onClick !== null && onClick !== void 0 ? onClick : handleSetView(v.id),
            selected: selected,
            showDropdown: showDropdown
          }, /*#__PURE__*/_react["default"].createElement(TitleWrapper, {
            title: v.label,
            unreadMessageCount: index === 0 ? unreadMessageCount : undefined
          }), onClick && !disabled && /*#__PURE__*/_react["default"].createElement(DownCarrot, null));
        }
      };
    }).filter(Boolean);

    if (brand !== null && brand !== void 0 && (_brand$preferenceTemp = brand.preferenceTemplates) !== null && _brand$preferenceTemp !== void 0 && _brand$preferenceTemp.length) {
      viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.push({
        id: "preferences",
        Component: function Component(_ref9) {
          var active = _ref9.active,
              selected = _ref9.selected,
              onClick = _ref9.onClick,
              showDropdown = _ref9.showDropdown;
          return /*#__PURE__*/_react["default"].createElement(DropdownOptionButton, {
            active: active,
            onClick: onClick !== null && onClick !== void 0 ? onClick : handleSetView("preferences"),
            selected: selected,
            showDropdown: showDropdown
          }, "Preferences", onClick && /*#__PURE__*/_react["default"].createElement(DownCarrot, null));
        }
      });
    }

    return viewOptions;
  }, [brand === null || brand === void 0 ? void 0 : (_brand$preferenceTemp2 = brand.preferenceTemplates) === null || _brand$preferenceTemp2 === void 0 ? void 0 : _brand$preferenceTemp2.length, title, unreadMessageCount]);
  var ActiveOption = options === null || options === void 0 ? void 0 : (_options$find = options.find(function (o) {
    return o.id === view;
  })) === null || _options$find === void 0 ? void 0 : _options$find.Component;
  var hasDropdownOptions = Boolean(options === null || options === void 0 ? void 0 : options.length);
  return /*#__PURE__*/_react["default"].createElement(Container, {
    "data-testid": "header"
  }, hasDropdownOptions ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(HeadingContainer, {
    hasDropdownOptions: hasDropdownOptions
  }, ActiveOption && /*#__PURE__*/_react["default"].createElement(ActiveOption, {
    selected: true,
    showDropdown: showDropdown,
    disabled: !hasDropdownOptions,
    onClick: handleShowDropdown
  })), showDropdown && /*#__PURE__*/_react["default"].createElement(HeadingDropdownOptions, null, options === null || options === void 0 ? void 0 : options.map(function (o) {
    return /*#__PURE__*/_react["default"].createElement(o.Component, {
      active: o.id === view,
      key: o.id
    });
  }).filter(Boolean))) : /*#__PURE__*/_react["default"].createElement(HeadingContainer, {
    tabIndex: 0
  }, /*#__PURE__*/_react["default"].createElement(TitleWrapper, {
    title: title,
    unreadMessageCount: unreadMessageCount
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "actions"
  }, messages.length > 0 && unreadMessageCount ? /*#__PURE__*/_react["default"].createElement(_MarkAllRead["default"], {
    label: labels === null || labels === void 0 ? void 0 : labels.markAllAsRead,
    onClick: function onClick() {
      return markAllAsRead();
    }
  }) : null, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    onClick: handleCloseInbox,
    tooltip: "Close Inbox"
  })));
};

var _default = Header;
exports["default"] = _default;